module.exports = __webpack_public_path__ + "static/media/Economy.cecd1993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/Economy.png
// module id = 631
// module chunks = 0